"use client";

import { IAirdropTaskRender } from "@/types/task-renderer.types";
import { TaskTypes } from "@/config/task-types";
import { resolveClickLink } from "@/lib/click-link";
import { QuestTaskButton } from "../QuestTaskButton";

export const ClickLinkRenderer = ({
  task,
  completeTaskMutation,
  campaign,
  challengesUser,
}: IAirdropTaskRender) => {
  const isShareProgress = task.taskName === TaskTypes.SHARE_PROGRESS;

  // Campaign tasks contain the link arguments; task statuses contain progress.
  const campaignTask = campaign.tasks?.find(
    (campaignTask) => campaignTask.id === task.taskGuid
  );
  const linkArgs = campaignTask?.arguments ?? [];

  // Function to handle share progress
  const handleShareProgress = (
    points: number,
    campaignName: string,
    referralCode?: string
  ) => {
    // Create the sharing text
    const shareText = `I've earned ${points} points in the ${campaignName} quest! Join me and earn rewards too.${
      referralCode ? ` Use my referral code: ${referralCode}` : ""
    }`;

    // Create Twitter sharing URL
    const twitterUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(
      shareText
    )}&url=${encodeURIComponent(window.location.origin)}`;

    // Open the sharing URL in a new tab
    window.open(twitterUrl, "_blank");
  };

  const handleClick = () => {
    if (isShareProgress) {
      const points = Number(challengesUser?.totalPoints ?? 0);
      const referralCode = challengesUser?.referralData?.code;
      const name = typeof campaign.metadata?.name === 'string' ? campaign.metadata.name : "Rhuna";

      handleShareProgress(points, name, referralCode);
    } else {
      const link = resolveClickLink(linkArgs);
      if (!link) return;
      window.open(link, "_blank", "noopener");
    }

    completeTaskMutation.mutateAsync({
      campaignId: campaign.id,
      groupId: campaign.campaignGroup,
      taskName: task.taskName,
      taskGuid: task.taskGuid,
    });
  };

  if (!isShareProgress && !resolveClickLink(linkArgs)) return null;

  return (
    <QuestTaskButton
      task={task}
      taskMutation={completeTaskMutation}
      buttonText={isShareProgress ? "Share Progress" : "Claim Reward"}
      onClick={handleClick}
      className="mt-4"
    />
  );
};
